import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { participantsApi } from "../../../utils";
import HeaderActionBar from "../Dashboard/HeaderActionBar/HeaderActionBar";
import CurriculumDesc from "./CurriculumDesc";
import classes from "./CurriculumPage.module.css"
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import ActionBar from "../Dashboard/ActionBar/ActionBar";
import { ParticipantTypeEnumText } from "../../../models/ParticipantTypeEnum";
import { onKeyDown } from "../../../service";


const CurriculumPage = ({ data, navigateToUrl }) => {

    const { srstudyGroupId } = useParams()
    const texts = useSelector(state => state.translate.texts);
    const { homeUrl } = useSelector(state => state.application);
    const { uiData } = useSelector((state) => state.general);
    const dispatch = useDispatch();
    const location = useLocation();
    const { state } = location;

    const connectStudyGroup = async () => {
        let data = {
            studyGroupId: srstudyGroupId,
            userExternalId: null,
            participantType: ParticipantTypeEnumText.student
        }
        participantsApi.participantsAddPost({ participantInput: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.participantsAddError, error: error, statusCode: response?.statusCode, message: "participantsAddPost " + error.message, level: 2, component: "CurriculumPage", line: 36 }))
            }
            else {
                if (state?.url) {
                    window.location.href = state.url
                }
                else if (navigateToUrl)
                    window.location.href = window.location.origin + uiData.baseNameStudent + navigateToUrl
                else
                    window.location.href = window.location.origin + process.env.PUBLIC_URL + homeUrl + '/' + srstudyGroupId;
            }
        })
    }
    return uiData && <div className={classes.CurriculumPage}>
        <HeaderActionBar />
        <div className={classes.ActionBar}>
            <ActionBar showActions={false}></ActionBar>
        </div>
        {data && <div className={classes.Wrap}>
            <div className={classes.Title} style={{ backgroundImage: `url(${data.pageBackgroundImage})` }}>
                <div className={classes.TitleContent}>
                    <NavLink to={"../"}>
                        <div className={classes.BackWrap}>
                            <div className={classes.BackImg}></div>
                            {texts.toAllCourse}
                        </div>
                    </NavLink>
                    <div className={classes.Name}>{data.name}</div>
                    <div className={classes.ConnectBtn} onClick={connectStudyGroup} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, connectStudyGroup)}>
                        <div className={classes.ConnectBtnIcon}>+</div>
                        <div className={classes.ConnectBtnText}> {texts.iWantLearn}</div>
                    </div>
                </div>
            </div>
            {data.fullDescription && <CurriculumDesc data={data} ></CurriculumDesc>}
        </div>
        }
    </div >
}

export default CurriculumPage;